
import List from "../../components/channels/List";
import Create from "../../components/channels/Create";
import authenticated from "../middleware/authenticated";
import connectToWebsocket from "../middleware/connectToWebsocket";

export default [
    {
        path: '/find-room',
        component: List,
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated
            ]
        }
    },
    {
        path: '/create-room',
        component: Create,
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated,
                connectToWebsocket
            ]
        }
    },
];